import { render, staticRenderFns } from "./propertyAdd.vue?vue&type=template&id=6fab9d0d&scoped=true&"
import script from "./propertyAdd.vue?vue&type=script&lang=js&"
export * from "./propertyAdd.vue?vue&type=script&lang=js&"
import style0 from "./propertyAdd.vue?vue&type=style&index=0&id=6fab9d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab9d0d",
  null
  
)

export default component.exports